import $ from 'jquery';
import urlParser from '../urlParser';

const sendMail = (emailBody, successCallback, failCallback) => {
	const branchTW = {
		xinzhuang: '新莊',
		taoyuan: '桃園',
		kaohsiung: '高雄',
		hualien: '花蓮',
	};

	const branchMailAdress = {
		kaohsiung: 'cdckh.service@ldchotels.com',
		hualien: 'cdchl.service@ldchotels.com',
		xinzhuang: 'cdcsj.service@ldchotels.com',
		taoyuan: 'cdcty.service@ldchotels.com',
	};

	$.ajax({
		type: 'POST',
		cache: false,
		url: '//www.25sprout.com/aws_ses/index_super.php',
		dataType: 'json',
		data: {
			mailer: 'aws',
			Source: 'no-reply@25sprout.com',
			ToAddresses: branchMailAdress[urlParser.branch],
			BccAddresses: '',
			Subject: `翰品${branchTW[urlParser.branch]}官網客服留言`,
			Body: emailBody,
			ReplyToAddresses: 'no-reply@25sprout.com',
			ReturnPath: 'no-reply@25sprout.com',
			Success: 'Success',
			Failed: 'Failed',
		},
		error: (xhr) => {
			if (failCallback) {
				failCallback(xhr);
			}
		},
		success: (data) => {
			if (successCallback) {
				successCallback(data);
			}
		},
	});
};

export default sendMail;



// WEBPACK FOOTER //
// ./src/js/request/sendMail.js